





































import Vue from 'vue'
import ProcedureDetailForm from '@/UI/Procedures/ProcedureDetailForm.vue'
import BatchDetail from '@/UI/Batch/BatchDetail.vue'
import Message from '@/UI/Shared/Message.vue'
import { ProcedureDto } from '@/Application/Procedures'
import { BatchDto } from '@/Application/Batch'

export default Vue.extend({
  name: 'BidProcedureDetailLayout',
  components: { ProcedureDetailForm, Message, BatchDetail },
  props: {
    procedure: {
      type: Object as () => ProcedureDto,
      required: true
    },
    riscoBatches: {
      type: Array as () => BatchDto[],
      required: true
    },
    resultasBatches: {
      type: Array as () => BatchDto[],
      required: true
    },
    errorLoading: {
      type: Boolean,
      default: false
    }
  }
})
